import React, { useState, useCallback } from "react";
import DataTable from "./DataTable";
import VPNSection from "./VPNSection";
import Footer from "./Footer";
import "../styles/VPNConsole.css";

function VPNConsole({ onShowToast }) {
  const [selectedDeviceId, setSelectedDeviceId] = useState(null);
  const [, setToastClosed] = useState(false);

  const handleDeviceSelect = (deviceId) => {
    setSelectedDeviceId(deviceId);
  };
  const handleToastClose = useCallback(() => {
    setToastClosed((prev) => !prev);
  }, []);

  return (
    <div className="vpn-console">
      <div className="left-panel">
        <DataTable
          onDeviceSelect={handleDeviceSelect}
          selectedDeviceId={selectedDeviceId}
        />
      </div>
      <div className="right-panel">
        <VPNSection
          selectedDeviceId={selectedDeviceId}
          onShowToast={(message, type) => {
            onShowToast(message, type);
            handleToastClose();
          }}
        />
      </div>
      <Footer />
    </div>
  );
}

export default VPNConsole;
